import i18next from "i18next";
import moment from "moment-timezone";
import { Fragment } from "react";

type ScheduleCalendarHorizontalGridProps = {
  step?: number;
  rowHeight?: string;
};

export default function ScheduleCalendarHorizontalGrid(
  props: ScheduleCalendarHorizontalGridProps
) {
  const { step = 1, rowHeight = "3.5rem" } = props;
  const startTime = moment().startOf("day");
  const numberOfSteps = 24 / step;
  const times = [...Array(numberOfSteps)].map((_, idx) =>
    startTime
      .clone()
      .locale(i18next.language)
      .add(idx * step, "hour")
      .format("hhA")
  );
  return (
    <div
      className="col-start-1 col-end-2 row-start-1 grid divide-y divide-gray-100"
      style={{
        gridTemplateRows: `repeat(${
          numberOfSteps * 2
        }, minmax(${rowHeight}, 1fr))`,
      }}
    >
      <div className="row-end-1 h-7"></div>

      {times.map((time) => (
        <Fragment key={`Time-${time}`}>
          <div>
            <div className="sticky ltr:left-0 rtl:right-0 z-0 -mt-2.5 ltr:-ml-14 rtl:-mr-14 w-14 ltr:pr-2 rtl:pl-2 text-end text-xs leading-5 text-gray-400 font-medium">
              {time}
            </div>
          </div>
          <div />
        </Fragment>
      ))}
    </div>
  );
}
